export default __webpack_public_path__ + "static/media/survey-background.83301ced.jpg";